import { NgModule } from '@angular/core';

import { HelpAndContactsContainerComponent } from './help-and-contacts.container';

import { HelpComponent } from './help/help.component';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MyContactsComponent } from './my-contacts/my-contacts.component';
import { SharedModule } from '../../shared/shared.module';
import { ContactUsModule } from './contact-us/contact-us.module';
import { MyConnectionsComponent } from './my-connections/my-connections.component';
import { MyConnectionsEffects } from './my-connections/my-connections.effects';
import { EffectsModule } from '@ngrx/effects';
import { MyContactsEffects } from './my-contacts/my-contacts.effects';
import { TabContentComponent, TabGroupComponent, TabsModule } from 'atlas-tabs';
import { IconModule } from 'atlas-icon';
import { ButtonModule } from 'atlas-button';
import { AccordionModule } from 'atlas-accordion';
import { AvatarModule } from 'atlas-avatar';

export const COMPONENTS = [
  HelpAndContactsContainerComponent,
  HelpComponent,
  MyContactsComponent,
  MyConnectionsComponent
];

@NgModule({
  declarations: COMPONENTS,
  imports: [
    RouterModule,
    CommonModule,
    // MercerOSModule,
    SharedModule,
    ContactUsModule,
    TabsModule,
    IconModule,
    ButtonModule,
    AccordionModule,
    AvatarModule,
    EffectsModule.forFeature([MyContactsEffects, MyConnectionsEffects])
  ],
  exports: COMPONENTS,
  providers: [],
  bootstrap: [],
})
export class HelpAndContactsModule {
}
